// Devine le type d'un document importé à partir de son nom — même heuristique que
// guessDocumentType dans scripts/boamp-fetch-documents/platforms/emarchespublics.mjs (circuit auto).
export function guessAoDocumentType(filename) {
  const lower = filename.toLowerCase();
  if (lower.includes('cctp')) return 'cctp';
  if (lower.includes('ccap')) return 'ccap';
  if (lower.includes('rc') || lower.includes('reglement') || lower.includes('règlement'))
    return 'rc';
  return 'autre';
}

// Le nom de fichier original est gardé pour l'affichage/la DB, mais la clé Storage doit être
// assainie : Supabase Storage rejette (« Invalid key ») les accents et certains caractères
// spéciaux dans les noms d'objets (ex. "critères" a fait échouer un upload en prod).
export function sanitizeStorageFilename(name) {
  return name
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-zA-Z0-9.\-]/g, '_');
}

// Documents d'un avis (la relation peut arriver en objet seul ou en liste).
export function noticeDocuments(notice) {
  if (Array.isArray(notice.boamp_documents)) return notice.boamp_documents;
  return notice.boamp_documents ? [notice.boamp_documents] : [];
}

// Résultat de boamp-analyze tel qu'enregistré sur l'avis.
export const analysisFromResult = (result, analyzedAt) => ({
  budget: result.budget,
  solution_demandee: result.solution_demandee,
  technologies_demandees_json: result.technologies_demandees,
  fonctionnalites_json: result.fonctionnalites,
  points_forts_json: result.points_forts,
  points_faibles_json: result.points_faibles,
  recommandation: result.recommandation,
  analyzed_at: analyzedAt,
});

// Miroir de la réévaluation de score faite côté serveur (voir boamp-analyze/logic.ts) — évite
// un rechargement de page pour voir le score corrigé après lecture du dossier complet. Pas de
// 'non_pertinent' ici volontairement (voir logic.ts) : ne doit jamais faire disparaître l'avis.
const SCORE_DOC_TOTAL = { fort: 6, moyen: 4, faible: 1 };
export const scoreUpdateFrom = (result) =>
  result.score_documentaire in SCORE_DOC_TOTAL
    ? {
        score_niveau: result.score_documentaire,
        score_total: SCORE_DOC_TOTAL[result.score_documentaire],
      }
    : {};
